import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function modalOpenStateReducer(state = initialState.isModalOpen, action) {
	switch (action.type) {
		case types.SET_IS_MODAL_OPEN: {
			return action.isModalOpen;
		}
		default:
			return state;
	}
}

export function ADCModalOpenStateReducer(state = initialState.isADCModalOpen, action) {
	switch (action.type) {
		case types.SET_IS_ADC_MODAL_OPEN: {
			return action.isADCModalOpen;
		}
		default:
			return state;
	}
}

export function modalLevelStateReducer(state = initialState.modalLevel, action) {
	switch (action.type) {
		case types.SET_MODAL_LEVEL: {
			return action.modalLevel;
		}
		default:
			return state;
	}
}
